import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item'];

  static values = {
    interval: { type: Number, default: 4000 },
  };

  #timer = null;
  #activeIndex = 0;

  connect() {
    if (this.itemTargets.length < 2) return;

    this.#timer = setInterval(() => this.#showNext(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.#timer);
    this.#timer = null;
  }

  #showNext() {
    this.#activeIndex = (this.#activeIndex + 1) % this.itemTargets.length;

    this.itemTargets.forEach((item, index) => {
      const isActive = index === this.#activeIndex;

      item.classList.toggle('opacity-100', isActive);
      item.classList.toggle('opacity-0', !isActive);
    });
  }
}
